import {makeStyles} from '@material-ui/core/styles';
import {CremaTheme} from '../../../../types/AppContextPropsType';
import {Fonts} from '../../../../shared/constants/AppEnums';

const useStyles = makeStyles((theme: CremaTheme) => ({
  fontBold: {
    fontFamily: Fonts.MEDIUM,
  },
  root: {
    cursor: 'pointer',
    minHeight: 48,
    width: 'auto',
    '&:hover': {backgroundColor: theme.palette.text.disabled},
    '&.active, &.active:hover, &.active:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.text.hint + '!important',
      pointerEvents: 'none',
      '& .list-item-text-primary': {
        color: 'inherit',
      },
      '& .list-item-icon': {
        color: 'inherit',
      },
    },
    '& .list-item-icon': {},
    '& .list-item-text': {
      padding: '0 0 0 16px',
    },
    color: theme.palette.text.primary,
    textDecoration: 'none!important',
    '&.dense': {
      padding: '8px 12px 8px 12px',
      minHeight: 40,
      '& .list-item-text': {
        padding: '0 0 0 8px',
      },
    },
  },
}));
export default useStyles;
